import _ from 'lodash';
import axios from 'axios';

const { BROWSER } = process.env;

class ApiClient {

  constructor(ctx) {
    this.ctx = ctx;

    if (BROWSER) {
      this.baseURL = '/api';
    } else {
      this.baseURL = 'https://platform.franklyinc.com/api';
    }
  }

  getConfig(config = {}) {
    config.method = config.method || 'get';
    config.responseType = config.responseType || 'json';
    config.headers = _.defaults(config.headers, {});
    config.url = (config.baseURL || this.baseURL) + (config.url || '');

    if (BROWSER) {
      // Add CORS credentials on browser side
      config.withCredentials = (config.withCredentials === undefined) ?
        true : config.withCredentials;
    } else {
      // Copy cookies into headers on server side
      const cookie = this.ctx.get('cookie');
      if (cookie) {
        config.headers = _.defaults(config.headers, {
          cookie
        });
      }

      config.headers['frankly-affiliate-host'] = this.ctx.hostname;
    }

    return config;
  }

  async request(config = {}) {
    try {
      const { data } = await axios(this.getConfig(config));

      return data;
    } catch (error) {
      // Convert to client friendly error
      if (error.response) {
        throw _.pick(error.response, ['data', 'status', 'statusText']);
      } else {
        throw {
          status: 0,
          data: {
            message: error.message
          }
        };
      }
    }
  }

}

export default ApiClient;



// WEBPACK FOOTER //
// ./shared/api-client.js